import { LazilyLoadFactory } from "../../layout/lazilyload";
import CaptchaContainer from "./container";

export default LazilyLoadFactory(CaptchaContainer, {
    Captcha: () => import("./container").then((component) => component.default),
});
